<div class="flex-center">
    <div class="thank-you-section auto-margins">
        <img src="../../../../../../assets/images/round-checkmark.png" />
    </div>
    <h1>Thank You</h1>
    <div class="text-center thank-you-message">
        You will receive an email with your account details once your user account has been approved.
    </div>
</div>